export { Heading, headingLevelClassNames } from "./Heading"
export type { HeadingProps, HeadingLevel } from "./Heading"
